export class RatingStarsController {
    constructor(root, params) {
        this._root = root;
        this._imgPath = '//res.cloudinary.com/hopwork/image/upload/joy/icons/';

        this._params = {
            RATE: params.dataRate || 0,
            SIZE: params.dataSize || 14,
        };
    }

    _insertRatingStarsInDom() {
        this._root.insertAdjacentHTML('beforeend', this._ratingStarsWrapper());
    }

    _stars(rating, size) {
        let icons = '';
        let on = 0.24;
        let half = 0.75;

        for (let i = 0; i < 5; i++) {
            let img = '';

            if (rating > on) {
                if (rating < half) {
                    img = `<img alt="star-half" width="${size}" height="${size}" src="${this._imgPath}star-half.svg" />`;
                } else {
                    img = `<img alt="star" width="${size}" height="${size}" src="${this._imgPath}star.svg" />`;
                }
            } else {
                img = `<img alt="star-empty" width="${size}" height="${size}" src="${this._imgPath}star-empty.svg" />`;
            }

            icons += `<li>${img}</li>`;
            on += 1;
            half += 1;
        }

        return icons;
    }

    // Building Stars Wrapper
    _ratingStarsWrapper() {
        const rating = parseFloat(this._params.RATE);
        return `${this._stars(rating, this._params.SIZE)}`;
    }

    refreshParams(params = {}) {
        this._root.innerHTML = '';
        this._updateParams(params);
        this.initialize();
    }

    _updateParams(params) {
        this._params = Object.assign(this._params || {}, params);
    }

    initialize() {
        this._insertRatingStarsInDom();
    }

    destroy() {
        this._root = null;
        this._params = null;
    }
}
